import { useState } from 'react';
import { Check } from 'lucide-react';
import ContactFormDialog from './ContactFormDialog';

const pricingPlans = [
  {
    name: 'Essentials',
    price: '$45',
    fee: 'Federal Filing Fee',
    features: [
      'Case Review',
      'Case Filing',
      'Basic Search',
      'State E-Filing',
      'Trademark Secured',
    ],
    note: '(Govt. filing fee not included)',
  },
  {
    name: 'Enhanced',
    price: '$149',
    fee: 'Federal Filing Fee',
    features: [
      'Case Review',
      'Case Filing',
      'Direct Hit Search',
      'Trademark Alert',
      'Trademark Secured',
      'High Satisfaction Rate',
      'Refusal Risk Meter',
    ],
    note: '(Govt. filing fee not included)',
  },
  {
    name: 'Deluxe',
    price: '$299',
    fee: 'Federal Filing Fee',
    recommended: true,
    features: [
      'Case Review',
      'Case Filing',
      'Direct Hit Search',
      'Trademark Alert',
      'Trademark Secured',
      'High Satisfaction Rate',
      'Refusal Risk Meter',
      'Trademark Monitoring',
      'Complete Documentation',
      'Digital File',
      'Dedicated Case Manager',
    ],
    note: '(Govt. filing fee not included)',
  },
  {
    name: 'Platinum',
    price: '$349',
    fee: 'Federal Filing Fee',
    features: [
      'Case Review',
      'Case Filing',
      'Direct Hit Search',
      'Trademark Alert',
      'Trademark Secured',
      'High Satisfaction Rate',
      'Refusal Risk Meter',
      'Trademark Monitoring',
      'Complete Documentation',
      'Digital File',
      'Dedicated Case Manager',
      'High Approval Rate',
      'Comprehensive Search Report',
      'High Priority Service',
      'Cease & Desist Letter',
    ],
    note: '(Govt. filing fee not included)',
  },
];

export const PricingTable = () => {
  const [showDialog, setShowDialog] = useState(false);
  const [selectedPlan, setSelectedPlan] = useState({ name: 'Essentials', price: 45 });

  const handleSelectPlan = (plan) => {
    const numericPrice = parseInt(plan.price.replace(/\D/g, ''), 10) || 45;
    setSelectedPlan({ name: plan.name, price: numericPrice });
    setShowDialog(true);
  };

  return (
    <>
      <div className="section bg-[#FFF5E6]" data-testid="pricing-section">
        <div className="container mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-[#06214c] mb-4" style={{ fontFamily: 'Playfair Display' }}>
              Choose Your Plan
            </h2>
            <p className="text-lg text-[#2C1810] max-w-2xl mx-auto">
              Select the perfect package to protect your brand and secure your trademark with confidence.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {pricingPlans.map((plan, index) => (
              <div
                key={index}
                className={`relative bg-white rounded-2xl shadow-lg overflow-hidden transition-transform hover:scale-105 ${
                  plan.recommended ? 'ring-4 ring-[#06214c]' : ''
                }`}
                data-testid={`pricing-plan-${plan.name.toLowerCase()}`}
              >
                {plan.recommended && (
                  <div className="absolute top-0 right-0 bg-[#06214c] text-white px-4 py-1 text-sm font-semibold rounded-bl-lg">
                    Recommended
                  </div>
                )}
                <div className="p-6">
                  <h3 className="text-2xl font-bold text-[#06214c] mb-2" style={{ fontFamily: 'Playfair Display' }}>
                    {plan.name}
                  </h3>
                  <div className="mb-4">
                    <div className="text-3xl font-bold text-[#2C1810]">{plan.price}</div>
                    <div className="text-sm text-gray-600">+ {plan.fee}</div>
                  </div>
                  <div className="h-64 overflow-y-auto mb-4 space-y-2">
                    {plan.features.map((feature, fIndex) => (
                      <div key={fIndex} className="flex items-start space-x-2">
                        <Check className="text-[#06214c] flex-shrink-0 mt-1" size={16} />
                        <span className="text-sm text-[#2C1810]">{feature}</span>
                      </div>
                    ))}
                  </div>
                  <div className="text-xs text-gray-500 mb-4">{plan.note}</div>
                  <button
                    onClick={() => handleSelectPlan(plan)}
                    className="w-full btn-primary"
                    data-testid={`select-plan-${plan.name.toLowerCase()}`}
                  >
                    Get Started
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <ContactFormDialog
        open={showDialog}
        onOpenChange={setShowDialog}
        source="pricing"
        packageTitle={selectedPlan.name}
        packageAmount={selectedPlan.price}
      />
    </>
  );
};

export default PricingTable;